import { connect } from "react-redux";

import {
  userSelectsSecondaryAreaFilterType,
  userSelectsSecondaryAreaOption,
  userSelectsSecondaryCategoryFilterType,
  userSelectsSecondaryCategoryOption
} from "../actions/secondary_filters";
import SecondaryFilters from "../components/secondary_filters";

const mapStateToProps = (state) => {
  let f = state.filters;

  let base = {
    selectedPrimaryTypeId: f.primaryFilter.selectedTypeId,
    selectedViewTypeId: f.viewType.id,
  };
  if (!f.secondaryFilters) return base;

  return Object.assign(base, {
    areaTypeId: f.secondaryFilters.areaTypeId,
    areaOption: f.secondaryFilters.areaOption,
    categoryTypeId: f.secondaryFilters.categoryTypeId,
    categoryOption: f.secondaryFilters.categoryOption,
  });
};

const mapDispatchToProps = dispatch => ({
  userSelectsSecondaryAreaFilterType: (e) => { dispatch(userSelectsSecondaryAreaFilterType(e)); },
  userSelectsSecondaryAreaOption: (e) => { dispatch(userSelectsSecondaryAreaOption(e)); },
  userSelectsSecondaryCategoryFilterType: (e) => { dispatch(userSelectsSecondaryCategoryFilterType(e)); },
  userSelectsSecondaryCategoryOption: (e) => { dispatch(userSelectsSecondaryCategoryOption(e)); },
});

export default connect(mapStateToProps, mapDispatchToProps)(SecondaryFilters);
